module.exports = __webpack_public_path__ + "static/media/learning-icon.99a15364.png";